import { InformationRequirement } from './InformationRequirement';
import { KnowledgeRequirement } from './KnowledgeRequirement';
import { AuthorityRequirement } from './AuthorityRequirement';
import { Association } from './Association';

export const EDGES = [
  InformationRequirement,
  KnowledgeRequirement,
  AuthorityRequirement,
  Association,
];

export function registerEdges(lf) {
  EDGES.forEach(({ type, view, model }) => {
    lf.register({ type, view, model });
  });
}
